import React, { useCallback } from 'react';

import { PathUrl, I18nText, GADataType } from '../../../../../../types';

import { LifestylesFiltersNavBasePath } from '../../../../lifestylesTypes';

import { NextPureLinkHelper } from '../../../../../../helpers/links/NextPureLinkHelper';
import { Translate } from '../../../../../../helpers/Translate';

interface LifestylesIndexPageBreadcrumbsItemProps {
  active: boolean;
  filtersNavBasePath?: LifestylesFiltersNavBasePath;
  href?: PathUrl;
  i18nText?: I18nText;
  onChangeFilters?: () => void;
  text?: string;
}

function LifestylesIndexPageBreadcrumbsItem({
  active,
  dataGa,
  filtersNavBasePath,
  href,
  i18nText,
  onChangeFilters,
  text
}: LifestylesIndexPageBreadcrumbsItemProps & GADataType) {
  const handleLinkClick = useCallback<
    (e: React.MouseEvent<HTMLAnchorElement>) => void
  >(
    (e) => {
      if (!filtersNavBasePath && onChangeFilters) {
        e.preventDefault();
        onChangeFilters();
      }
    },
    [filtersNavBasePath, onChangeFilters]
  );

  if (active) {
    return (
      <span className="font-medium text-black dark:text-white">
        {i18nText ? <Translate id={i18nText} /> : text}
      </span>
    );
  }

  return (
    <NextPureLinkHelper
      className="hover:underline"
      dataGa={dataGa}
      href={href || '#'}
      i18nText={i18nText}
      onClick={handleLinkClick}
      text={text}
    />
  );
}

export default LifestylesIndexPageBreadcrumbsItem;
